import {PlatformService} from './../../../../presentation/services/platform.service';
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {HandlerParameters} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {Device} from "@capacitor/device";
import packageJson from 'package.json';
import {combineLatest, from, Observable, of} from "rxjs";
import {map, switchMap} from "rxjs/operators";
import {BaseHandler} from "@app/core/shared/infrastructure/base.handler/base.handler";
import {environment} from "src/environments/environment";
import {EnvironmentPlatform} from "src/environments/environment-template";


const SERVER_DEVICE_NAME = 'Server';

@Injectable({
  providedIn: 'root',
})
export class EuropastryBaseHandler extends BaseHandler {

  constructor(
    private platformService: PlatformService,
    http: HttpClient,
  ) {
    super(http);
  }

  protected addHeaders(parameters: HandlerParameters): Observable<Map<string, any>> {

    return super.addHeaders(parameters).pipe(
      switchMap(headerDict => {
        
        // Set the platform from which the application is accessed
        const platform = environment.PLATFORM;
        headerDict.set('Platform', platform);

        // Set the site
        headerDict.set('SITE', environment.SITE);

        // Set the application version number
        headerDict.set('Version-Number', packageJson.version);


        //Avoid browser apis and library calls on Server.
        if (this.platformService.isServer) {
          headerDict.set('Device-Name', SERVER_DEVICE_NAME);
          return of(headerDict);
        }

    // ---------- Add device headers ----------

    // If platform is web, set the browser name and a flag that indicates if cookies are enabled
        if (platform === EnvironmentPlatform.WEB) {
          headerDict.set('Browser', this.getBrowserName());
          headerDict.set('Cookies-Enabled', navigator.cookieEnabled.toString());
        }

        const deviceInfo$ = from(Device.getInfo());
        const languageCode$ = from(Device.getLanguageCode());

        // Wait for the observables to emit their value and add the corresponding headers
        return combineLatest([deviceInfo$, languageCode$]).pipe(
          map(([deviceInfo, languageCode]) => {
            // Set the device name 
            headerDict.set('Device-Name', deviceInfo.name ?? "");
            // Set the language code selected by the user
            headerDict.set('Language-Code', languageCode.value);
            return headerDict;
          })
        );
      })
    );
  }

  private getBrowserName() {
    if (navigator == null) {
      return 'unknown';
    } else if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return 'Firefox';
    } else if (navigator.userAgent.indexOf("MSIE") != -1) {
      return 'IE';
    } else {
      return 'unknown';
    }
  }
}
